import actions from "@/store/modules/consigned/actions";
import mutations from "@/store/modules/consigned/mutations";
import state from "@/store/modules/consigned/state";

export default {
    actions,
    mutations,
    state
}